<script lang="ts">
	import type { Component } from 'svelte';

	let { load }: { load: () => Promise<Component> } = $props();

	const loadComponent = (loader: () => Promise<Component>): Promise<Component | null> =>
		loader().catch((error: unknown) => {
			console.error('[lazy-component] failed to load component', error);
			return null;
		});

	let component = $derived(loadComponent(load));
</script>

{#await component then Loaded}
	{#if Loaded}
		<Loaded />
	{/if}
{/await}
